import React from "react";
import Select from "react-select";
import "./Dropdown.scss";

const Dropdown = React.forwardRef(({ className, styles, components, menuPlacement, ...props }, ref) => {
    return (
        <Select
            {...props}
            ref={ref}
            menuPlacement={menuPlacement}
            className={`customDropdown ${className ? className : ""}`}
            styles={styles}
            components={components || {}}
        />
    );
});

export default Dropdown;
